import React, { Component } from 'react';
import PropTypes from 'prop-types'
import getLocaleMessages from '../../utils/localesMessages';
import { copyToClipboard } from '../../lib/copyToClipBoard'; 

const {
	clipboard,
	html: {
		stepOne,
		stepTwo,
		stepThree,
		stepFour,
		stepFive
	}
} = getLocaleMessages('buttons/buttonCompleteDetails')

const ButtonDetailStep = (props) => {
	return (
		<div className="button-detail-step">
			<div className="step-num">
				<span>{props.stepNumber}</span>
			</div>
			<p className="step-content">{props.content}</p>
		</div>
	);
}

ButtonDetailStep.propTypes = {
	stepNumber: PropTypes.number,
	content: PropTypes.string
}

class ButtonHTML extends Component {
	static propTypes = {
		button: PropTypes.object
	}

	constructor(props) {
		super(props);
	}

	handleCopyToClipboard() {
		copyToClipboard('button-html');
	}

	render() {
		const steps = {
			's1': stepOne,
			's2': stepTwo,
			's3': stepThree,
			's4': stepFour,
			's5': stepFive
		}

		if (!this.props.button) {
			return null;
		}

		return (
			<div className="button-detail-body button-html">
				<ButtonDetailStep stepNumber={1} content={steps.s1}/>

				<div className="vx_panel">
					<textarea
						dir="ltr"
						className="vx_panel-info"
						id="button-html"
						value={this.props.button.website_code}
          >
					</textarea>

					<div className="clip-board">
						<img src="https://www.paypalobjects.com/images/Cause/ic_copy.svg" />
						<a onClick={this.handleCopyToClipboard}>{clipboard}</a>
					</div>
				</div>

				<ButtonDetailStep stepNumber={2} content={steps.s2} />
				<ButtonDetailStep stepNumber={3} content={steps.s3} />
				<ButtonDetailStep stepNumber={4} content={steps.s4} />
				<ButtonDetailStep stepNumber={5} content={steps.s5} />
			</div>
		)
	}
}
export default ButtonHTML;



// WEBPACK FOOTER //
// ./buttons/components/buttonDetails/ButtonHTML.js